import { render, staticRenderFns } from "./CongressTable.vue?vue&type=template&id=b8dab37c&scoped=true&"
import script from "./CongressTable.vue?vue&type=script&lang=js&"
export * from "./CongressTable.vue?vue&type=script&lang=js&"
import style0 from "./CongressTable.vue?vue&type=style&index=0&id=b8dab37c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8dab37c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VDataTable,VPagination,VSelect})
